import MCHCHAN from '@/api/module/mchchan.js';
const MERCHANTS = {
  namespaced: true,
  state: {
    merchantInfo: {},
    bandsCon:{},
    searchForm: {
      startTime: '', //开始时间
      endTime: '', //结束时间
      keyWord: '', //关键字
      accountType: '', //商户账户类型
      mainMerchant:'',//分账方商户号
      pageNum: 1,
      pageSize: 10,
    },
    bindsInfo: {
      mainMerchant: '', //分账方商户号
      accountId: '', //分账接收方商户号/登录号
      accountType: '', //商户账户类型(userId:个人,merchant:商户)
      accountName: '', //商户名称
      relationType: '', //关系描述
      channel: '汇付宝', //支付渠道
      merchantType: '', //商户类型
      mainMerchantName: '', //主商户名称-应用名称（默认回显）
    },
  },
  mutations: {
    //获取绑定关系列表
    bandsCon(state, data){
      state.bandsCon=data;
    },
    bindsInfo(state, data){
      state.bindsInfo=data;
    }
  },
  actions: {
    //新增分账绑定关系
    // eslint-disable-next-line
    async saveRelation({ commit }, params) {
      try {
        const result = await MCHCHAN.saveRelation(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    //获取绑定关系列表
    async getBinds({ commit }, params) {
      try {
        const result = await MCHCHAN.getBinds(params);
        commit('bandsCon', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    //修改绑定关系
    // eslint-disable-next-line
    async updateRelation({ commit }, params) {
      try {
        const result = await MCHCHAN.updateRelation(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    //删除绑定关系
    // eslint-disable-next-line
    async deleteBind({ commit }, params) {
      try {
        const result = await MCHCHAN.deleteBind(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    //获取绑定关系详情
    async getBindInfo({ commit }, params) {
      try {
        const result = await MCHCHAN.getBindInfo(params);
        commit('bindsInfo', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {
    searchForm: state => state.searchForm,
    bindsInfo:state => state.bindsInfo,
    bandsCon: state => state.bandsCon,
  },
};
export default MERCHANTS;
